import script from "./PantallaInicio.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaInicio.vue?vue&type=script&setup=true&lang=js"

import "./PantallaInicio.vue?vue&type=style&index=0&id=0c73e49b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c73e49b"]])

export default __exports__